export const SupportEvent = {
  ProofOfReservesAuditTimeClick: 'proof_of_reserves_audit_time_click',
} as const;

export interface SupportEventDataType {
  [SupportEvent.ProofOfReservesAuditTimeClick]: {
    audit_time?: string;
  };
}
